/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/12/2021
 */
import FormElementType from "@/core/modules/coach/Resources/Forms/model/FormElements/FormElementType";
import BaseSmartFormElement from "@/core/modules/coach/Resources/Forms/model/FormElements/Smart/BaseSmartFormElement";

export default class FormElementPhoneNumber extends BaseSmartFormElement {


	constructor(title, options = {}) {
		super(FormElementType.PHONE_NUMBER, title, {required: true, ...options});
	}

	resetElement() {
		super.resetElement();
		this.title = "Phone Number"
		this.isRequired = true
		this.showRequiredSwitch = false
		this.placeholder = "Phone Number Question Text"
		// this.disableEditing = true
		// this.specialQuestionDescription = "phone number"
	}

	getSpecialQuestionDescription(){
		return "phone number"
	}

	getSmartFiledPropertyName(){
		return "phone"
	}

}
